import { FC } from "react";
import { IconNames } from "../../components/Icons/styles/iconNames";
import { InsuranceTypeItem } from "./components/SelectInsuranceType";
import Dashboard from ".";
import {
  Services,
  useGetDocumentsDashboardCountersQuery,
  useGetDocumentsDashboardTotalValuesQuery,
} from "../../graphql/__GENERATED__/types";
import { DocumentsLocation, ToDocumentDetailsLocation } from "../../Locations";
import {
  dashboardCategoryDocumentFilters,
  dashboardStatusDocumentFilters,
} from "../../filters/documents";
import { documentsCharts } from "./assets/dashboardCharts";
import useDashboardCharts from "./hooks/useDashboardCharts";
import useDashboardTotals from "./hooks/useDashboardTotals";
import { documentsTotals } from "./assets/dashboardTotals";
import useDocumentsDashboard from "../../hooks/useDashboard";

const DocumentsDashboard: FC = () => {
  const insuranceTypes: InsuranceTypeItem[] = [
    {
      label: "Seguro Rural",
    },
    {
      iconName: IconNames.Agriculture,
      label: "Agrícola",
      disabled: true,
    },
    {
      iconName: IconNames.Benefectory,
      label: "Benfeitorias",
      disabled: true,
    },
    {
      iconName: IconNames.Company,
      label: "Empresarial",
      disabled: true,
    },
    {
      iconName: IconNames.Forest,
      label: "Floresta",
      disabled: true,
    },
    {
      iconName: IconNames.Machine,
      label: "Máquinas",
      disabled: true,
    },
    {
      iconName: IconNames.Pecuary,
      label: "Pecuária",
      disabled: true,
    },
  ];

  const { data: chartsData, loading: chartsDataLoading } =
    useGetDocumentsDashboardCountersQuery({
      variables: { filter: {} },
    });

  const categoryFilters = dashboardCategoryDocumentFilters()!;
  const statusFilters = dashboardStatusDocumentFilters()!;

  const documentsChartsData = useDashboardCharts(
    categoryFilters,
    statusFilters,
    documentsCharts,
    chartsData?.getDocumentsDashboardCounters!,
    chartsDataLoading,
    DocumentsLocation
  );

  const { totalDataDateRange } = useDocumentsDashboard();

  const { data: totalsData, loading: totalsDataLoading } =
    useGetDocumentsDashboardTotalValuesQuery({
      variables: {
        input: totalDataDateRange,
      },
    });

  const documentsTotalsData = useDashboardTotals(
    documentsTotals,
    totalsData?.getDocumentsDashboardTotalValues!,
    totalsDataLoading
  );

  return (
    <Dashboard
      serviceName={Services.Documents}
      docIdRedirectLocation={(docId) => ToDocumentDetailsLocation(docId)}
      typeSelection={insuranceTypes}
      chartData={documentsChartsData}
      totalData={documentsTotalsData}
    />
  );
};

export default DocumentsDashboard;
